import {
    InputAdornment,
    Stack,
    TextField,
    Typography,
    Box,
    Link,
    Switch,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import React, {useContext, useState} from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import {useForm, Controller} from "react-hook-form";
import axios from "../../axiosConfig";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {LoadingButton} from '@mui/lab';
import {passwordValidationPattern} from "../../constants/index"
import { useTranslation } from "react-i18next";

const loginFieldSx = {
  "& .MuiInputBase-root": {
    padding: 0,
    border: "1px solid #E4E9EF",
    borderRadius: "14px",
    overflow: "hidden",
    backgroundColor: "#fff",
    filter: "drop-shadow(0px 3px 3px rgba(0,0,0,0.16))",
  },
  "& input": {
    border: "none !important",
    filter: "none !important",
    boxShadow: "none !important",
    borderRadius: "0 !important",
  },
  "& .MuiInputAdornment-root": { m: 0 },
};



const ResetPasswordForm = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const {
        handleSubmit,
        control,
        setError,
        formState: {errors},
        watch
    } = useForm({
        mode: "onChange",
    });
    const {password} = watch();
    const [showPassword, setShowPassword] = useState(false);
    const onPasswordClicked = () => {
        setShowPassword((prevState) => !prevState);
    };
    const {userId, code} = useParams();
    const nav = useNavigate();
    const onSubmit = (data) => {
        setIsLoading(true);
        axios.post(`/Auth/ResetPassword`, {userId, code, newPassword: data.password}).then(res => {
            setIsLoading(false);
            nav(`/login`);
        }).catch(e => {
            setIsLoading(false);
            setError("confirmPassword", {message: e.response.data.message});
        });
    }
    return (
        <Stack sx={{p: 3, width: "90%", gap: 5}}>
            <Typography
                sx={{fontWeight: "bold", alignSelf: "center"}}
                color="primary.main"
                variant="h5"
            >
                {t('resetPw_title')}
            </Typography>
            <Stack>
                <Typography sx={{fontWeight: "bold"}}>{t('resetPw_password')}</Typography>
                <Controller
                    name="password"
                    control={control}
                    rules={{
                        required: t('resetPw_passwordRequired'),

                        pattern: {
                            value: passwordValidationPattern,
                            message: t('resetPw_passwordPattern')
                        }
                    }}
                    render={({field}) => (
                        <TextField
                            {...field}
                            type={showPassword ? "text" : "password"}
                            variant="standard"
                            sx={loginFieldSx}
                            inputProps={{ style: { textAlign: "center", height: 48, padding: 0 } }}
                            InputProps={{
                                disableUnderline: true,
                                placeholder: t('resetPw_passwordPlaceholder'),
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 48, height: 48, backgroundColor: "#EAF0F7" }}>
                                            <IconButton onClick={onPasswordClicked}>
                                                {showPassword ? <VisibilityOffIcon color="primary"/> : <VisibilityIcon color="primary"/>}
                                            </IconButton>
                                        </Box>
                                    </InputAdornment>
                                ),
                            }}
                            FormHelperTextProps={{ sx: { textAlign: "start" } }}
                            error={!!errors.password}
                            helperText={errors.password ? errors.password.message : ""}
                        />
                    )}
                />
            </Stack>
            <Stack>
                <Typography sx={{fontWeight: "bold"}}>{t('resetPw_confirmPassword')}</Typography>
                <Controller
                    name="confirmPassword"
                    control={control}
                    rules={{
                        required: t('resetPw_confirmRequired'),
                        validate: (value) => value === password ? true : t('resetPw_mismatch')
                    }}
                    render={({field}) => (
                        <TextField
                            {...field}
                            type={showPassword ? "text" : "password"}
                            variant="standard"
                            sx={loginFieldSx}
                            inputProps={{ style: { textAlign: "center", height: 48, padding: 0 } }}
                            InputProps={{
                                disableUnderline: true,
                                placeholder: t('resetPw_confirmPlaceholder'),
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 48, height: 48, backgroundColor: "#EAF0F7" }}>
                                            <IconButton onClick={onPasswordClicked}>
                                                {showPassword ? <VisibilityOffIcon color="primary"/> : <VisibilityIcon color="primary"/>}
                                            </IconButton>
                                        </Box>
                                    </InputAdornment>
                                ),
                            }}
                            FormHelperTextProps={{ sx: { textAlign: "start" } }}
                            error={!!errors.confirmPassword}
                            helperText={errors.confirmPassword ? errors.confirmPassword.message : ""}
                        />
                    )}
                />
            </Stack>

            <LoadingButton
                type="sumbit"
                loading={isLoading}
                onClick={handleSubmit(onSubmit)}
                sx={{width: "80%", alignSelf: "center"}}
                variant="contained"
            >
                <Typography>{t('resetPw_submit')}</Typography>
            </LoadingButton>
        </Stack>
    );
};
export default ResetPasswordForm;
